import React, { useState, useEffect } from "react";

import { useHistory, useParams, useLocation } from "react-router-dom";
import { format, intervalToDuration } from "date-fns";

import { FaDownload } from "react-icons/fa";

import { Link, Icon, Text, Flex, SimpleGrid, Box } from "@chakra-ui/react";

import Group from "../../ServicosAcolhimento/Visualizar/Group";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { TableDocumentacao } from "./Table";
import { API } from "../../../../main/config";
import { CustomButton } from "../../../components/CustomButton";

import { cpf } from "../../../utils/masks";
import DocumentacaoService from "../../../../main/services/DocumentacaoService";
import CriancaService from "../../../../main/services/CriancaService";
import Information from "../../ServicosAcolhimento/Visualizar/Information";
import {
  Permission,
  vrCriancaFunc,
  criancaFunc,
} from "../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import Swal from "sweetalert2";
import { certidaoNascimento } from "../../../utils/masks";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { HINT_PORTAL_EXTRAJUDICIAL } from "../../../../helpers/hints";

export const VisualizarDocumentacao = ({ dataNascimento }) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { id } = useParams();
  const history = useHistory();
  const isNascidoAposMar2011 =
    dataNascimento >= new Date("2011-03-01").getTime();
  const [data, setData] = useState();
  const [dataCrianca, setDataCrianca] = useState();
  const [columnsRegistro, setColumnsRegistro] = useState([]);
  const [columnsIdentidade, setColumnsIdentidade] = useState([]);
  const [columnsCPF, setColumnsCPF] = useState([]);
  const {
    atualizarDocumentacao,
    setAtualizarDocumentacao,
    cadastrarDocumentacao,
    setCadastrarDocumentacao,
    setEditarCriancaCr,
    idPJ,
  } = useAppContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");

  useEffect(() => {
    setEditarCriancaCr(false);
  }, [setEditarCriancaCr]);

  useEffect(() => {
    if (atualizarDocumentacao) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then(function () {
        setAtualizarDocumentacao(false);
      });
    } else if (cadastrarDocumentacao) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then(function () {
        setCadastrarDocumentacao(false);
      });
    }
  }, [
    atualizarDocumentacao,
    setAtualizarDocumentacao,
    cadastrarDocumentacao,
    setCadastrarDocumentacao,
  ]);

  useEffect(() => {
    DocumentacaoService.getDocumentacao(id)
      .then((res) => {
        setData(res.data);

        if (res.data.numeroSolicitacaoCertNascimento) {
          setColumnsRegistro([
            {
              Header: "Matrícula",
              accessor: "matricula",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? certidaoNascimento(props.value) : ""}
                  </span>
                );
              },
            },
            ...(!isNascidoAposMar2011
              ? [
                  {
                    Header: "Livro",
                    accessor: "livro",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                  {
                    Header: "Folha",
                    accessor: "folha",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                  {
                    Header: "Termo",
                    accessor: "termo",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                ]
              : []),
            {
              Header: "Arquivo",
              accessor: "certidao",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsRegistro([
            {
              Header: "Matrícula",
              accessor: "matricula",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            ...(!isNascidoAposMar2011
              ? [
                  {
                    Header: "Livro",
                    accessor: "livro",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                  {
                    Header: "Folha",
                    accessor: "folha",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                  {
                    Header: "Termo",
                    accessor: "termo",
                    Cell: (props) => <span>{props.value || ""}</span>,
                  },
                ]
              : []),
            {
              Header: "Arquivo",
              accessor: "certidao",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        }
        if (res.data.numeroSolicitacaoIdentidade) {
          setColumnsIdentidade([
            {
              Header: "Nº da identidade",
              accessor: "numeroIdentidade",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Órgão Expedidor",
              accessor: "orgaoExpedidor",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Data de expedição",
              accessor: "dataExpedicaoIdentidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value ? format(props.value, "dd/MM/yyyy") : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "identidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsIdentidade([
            {
              Header: "Nº da identidade",
              accessor: "numeroIdentidade",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Órgão Expedidor",
              accessor: "orgaoExpedidor",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Data de expedição",
              accessor: "dataExpedicaoIdentidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value ? format(props.value, "dd/MM/yyyy") : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "identidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        }
        if (res.data.numeroSolicitacaoCPF) {
          setColumnsCPF([
            {
              Header: "Nº do CPF",
              accessor: "cpf",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? cpf(props.value) : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "anexoCpf",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsCPF([
            {
              Header: "Nº do CPF",
              accessor: "cpf",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? cpf(props.value) : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "anexoCpf",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Link
                        href={
                          props.value.path.toString().includes(".png") ||
                          props.value.path.toString().includes(".jpg") ||
                          props.value.path.toString().includes(".jpeg") ||
                          props.value.path.toString().includes(".pdf")
                            ? API +
                              `/criancas/anexos/${props.value.id}/visualizar`
                            : API +
                              `/criancas/anexos/${props.value.id}/download`
                        }
                        target="_blank"
                      >
                        <Icon
                          aria-label="Download"
                          color="#006064"
                          as={FaDownload}
                          boxSize="18px"
                          _hover={{ cursor: "pointer" }}
                        />
                      </Link>
                    )}
                  </span>
                );
              },
            },
          ]);
        }
      })
      .catch((error) => {
        let path = `/crianca/cadastrar-documentacao/${id}`;
        path += idAnexo ? `?idAnexo=${idAnexo}` : "";
        history.replace(path);
      });

    CriancaService.getCrianca(id)
      .then((res) => {
        setDataCrianca(res.data);
      })
      .catch((err) => console.log("Erro no get de crianca"));
  }, [history, id, idAnexo, isNascidoAposMar2011]);

  const columnsCTPS = [
    {
      Header: "Número da CTPS",
      accessor: "numeroCtps",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
    {
      Header: "Série",
      accessor: "serieCtps",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
    {
      Header: "Data da Expedição",
      accessor: "dataExpedicaoCtps",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Arquivo",
      accessor: "ctps",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.path.toString().includes(".png") ||
                  props.value.path.toString().includes(".jpg") ||
                  props.value.path.toString().includes(".jpeg") ||
                  props.value.path.toString().includes(".pdf")
                    ? API + `/criancas/anexos/${props.value.id}/visualizar`
                    : API + `/criancas/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  const columnsCartaoNacionalSUS = [
    {
      Header: "Nº do Cartão do SUS",
      accessor: "numeroCartaoSus",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
  ];

  const columnsNumeroIdentidadeSocial = [
    {
      Header: "Número de Identificação Social",
      accessor: "numeroIdentidadeSocial",
      Cell: (props) => {
        return (
          <span title={props.value}>{props.value ? props.value : ""}</span>
        );
      },
    },
  ];

  return roleKeycloack &&
    (roleKeycloack?.includes(vrCriancaFunc.documentacaoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    data && dataCrianca ? (
      <Flex flexDir="column">
        <Group
          title="Registro de Nascimento"
          tooltipText={HINT_PORTAL_EXTRAJUDICIAL}
        >
          {data.registrada.trim() === "S" ? (
            <TableDocumentacao columns={columnsRegistro} data={[data]} />
          ) : (
            <Text mt="25px" fontWeight={"bold"}>
              {data.registrada.trim() === "N" ? "Não Possui" : "Sem Informação"}
            </Text>
          )}
          {data.numeroSolicitacaoCertNascimento && (
            <Information
              title="Número de solicitação do documento ao órgão responsável:"
              information={data ? data.numeroSolicitacaoCertNascimento : ""}
            />
          )}
        </Group>

        <Group title="Identidade">
          {data.possuiIdentidade.trim() === "S" ? (
            <TableDocumentacao columns={columnsIdentidade} data={[data]} />
          ) : (
            <Text mt="25px" fontWeight={"bold"}>
              {data.possuiIdentidade.trim() === "N"
                ? "Não Possui"
                : "Sem Informação"}
            </Text>
          )}
          {data.numeroSolicitacaoIdentidade && (
            <Information
              title="Número de solicitação do documento ao órgão responsável:"
              information={data ? data.numeroSolicitacaoIdentidade : ""}
            />
          )}
        </Group>

        <Group title="CPF">
          {data.possuiCpf.trim() === "S" ? (
            <TableDocumentacao columns={columnsCPF} data={[data]} />
          ) : (
            <Text mt="25px" fontWeight={"bold"}>
              {data.possuiCpf.trim() === "N" ? "Não Possui" : "Sem Informação"}
            </Text>
          )}
          {data.numeroSolicitacaoCPF && (
            <Information
              title="Número de solicitação do documento ao órgão responsável:"
              information={data ? data.numeroSolicitacaoCPF : ""}
            />
          )}
        </Group>
        {intervalToDuration({
          start: new Date(dataCrianca.dataNascimento),
          end: new Date(),
        }).years >= 16 && (
          <Group title="CTPS">
            {data?.possuiCtps?.trim() === "F" ? (
              <TableDocumentacao columns={columnsCTPS} data={[data]} />
            ) : (
              <Text mt="25px" fontWeight={"bold"}>
                {data?.possuiCtps?.trim() === "D"
                  ? "Digital: " + data.cpf
                  : data?.possuiCtps?.trim() === "N"
                  ? "Não Possui"
                  : "Sem Informação"}
              </Text>
            )}
          </Group>
        )}

        <Group title="Cartão Nacional do SUS">
          {data.possuiCartaoSus.trim() === "S" ? (
            <TableDocumentacao
              columns={columnsCartaoNacionalSUS}
              data={[data]}
            />
          ) : (
            <Text mt="25px" fontWeight={"bold"}>
              {data.possuiCartaoSus.trim() === "N"
                ? "Não Possui"
                : "Sem Informação"}
            </Text>
          )}
        </Group>

        <Group title="Número de Identificação Social">
          {data.possuiNumeroIdentidadeSocial.trim() === "S" ? (
            <TableDocumentacao
              columns={columnsNumeroIdentidadeSocial}
              data={[data]}
            />
          ) : (
            <Text mt="25px" fontWeight={"bold"}>
              {data.possuiNumeroIdentidadeSocial.trim() === "N"
                ? "Não Possui"
                : "Sem Informação"}
            </Text>
          )}
        </Group>

        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={vrCriancaFunc.documentacaoEditar}
            id={idPJ}
            user={user}
            visualizar={true}
          >
            <CustomButton
              label="Editar"
              onClick={() => {
                history.push(`/crianca/editar-documentacao/${id}`);
              }}
            />
          </Permission>
        </SimpleGrid>
      </Flex>
    ) : (
      <LoadingSpinner loading={true} />
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
